/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal, Leonid Khramov, Slobodan Djordjevic
 */
import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useHistory, useLocation } from "react-router"
import { useVideoControls } from "trux/dist/organisms/VideoPlayer"
import { Modal, ModalTitle, TitleSection, ContentSection, Column } from "trux"
import * as links from "../../util/links"
import * as act from "../Navigation/actions"

export const UserProfileLinksDialog = () => {
    const dispatch = useDispatch()
    const location = useLocation()
    const history = useHistory()
    const user = useSelector((state) => state.user.value)
    const acl = useSelector((state) => state.acl.value)
    const currentTeam = useSelector((state) => state.team.value)
    let extras = links.getUrlExtras(window.location.hash)
    const [open, setOpen] = useState(extras.user === "profile")
    const { pause, play } = useVideoControls()

    const doLogout = (e) => {
        dispatch(act.logoutUser())
        close(e)
    }

    const close = (e) => {
        if (e) {
            e.preventDefault()
        }
        history.push(location.pathname.replace(/\/user\/profile$/gi, ""))
        play()
    }

    useEffect(() => {
        setOpen(extras.user === "profile")
    }, [extras])

    useEffect(() => {
        if (open) {
            pause()
        }
    }, [open])

    if (!user || !user.user_id || !currentTeam) {
        return null
    }

    return (
        <Modal
            open={open}
            onShadeClick={close}
            trkContext="User Profile Dialog"
            className="user-profile-dlg"
        >
            <TitleSection onCloseClick={close}>
                <ModalTitle content={`${user.first_name} ${user.last_name}`} />
            </TitleSection>
            <ContentSection>
                <Column spacing="4">
                    <a
                        className="pb-4"
                        id="umenu-traceid-btn"
                        href={links.traceIdUrl(
                            `/find/user/${user.user_id}`,
                            acl
                        )}
                    >
                        My Trace iD
                    </a>
                    <a
                        className="pb-4"
                        id="umenu-games-btn"
                        href={`/#/${currentTeam.name}`}
                    >
                        My Games
                    </a>
                    <a className="pb-4" id="umenu-teams-btn" href="/#/">
                        My Teams
                    </a>
                    <a
                        className="pb-4"
                        id="umenu-helpc-btn"
                        href="http://traceup.com/soccer/help"
                    >
                        Help Center
                    </a>
                    <a
                        className="pb-4"
                        id="umenu-logout-btn"
                        href={`/#/${currentTeam.name}`}
                        onClick={(e) => {
                            doLogout(e)
                        }}
                    >
                        Log out
                    </a>
                </Column>
            </ContentSection>
        </Modal>
    )
}
